module.exports = __webpack_public_path__ + "static/media/ly.091c1151.svg";